// src/App.js
import React from "react";
import "./index.css";
import NeuroNudge from "./NeuroNudge";

export default function App() {
  return <NeuroNudge />;
}
